import { LitElement, html, nothing } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { formatDate } from '@nirvana/shared/time';
import { FontSizes, FontWeights } from '../../../../types/common/types';
import { getSeverityClassFromScore } from '../../../incidentsGrid/view/CustomGridRenderers';
import { GeneralSectionLabels } from '../../../xdrIncidentDetails';
import moment from 'moment';
import { INCIDENT_TYPE } from '../../../incidentsGrid/types';

/**
 * @summary Type here the description of this component
 * @tag incident-general-section
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement('incident-general-section')
export class IncidentGeneralSectionWebComponent extends LitElement {
  @property({
    type: String,
    attribute: true,
    reflect: true,
  })
  title = '';

  @property({
    type: Object,
    attribute: false,
    reflect: false,
  })
  incident;

  @property({
    type: Object,
    attribute: false,
    reflect: false,
  })
  translations: GeneralSectionLabels;

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html`
      <div>
        <gz-title
          fontSize="${FontSizes.PARAGRAPH_11}"
          fontWeight="${FontWeights.SEMIBOLD}"
          class="section-title text-uppercase mb-2"
          >${this.title}
        </gz-title>
        <gz-labeled-content label="${this.translations.id}">
          ${this.incident.isGzDemo && this.incident.type === INCIDENT_TYPE.XDR
            ? 'DEMO'
            : this.incident.number}</gz-labeled-content
        >
        <gz-labeled-content label="${this.translations.created}">
          ${moment(this.incident.created).format('DD MMM YYYY, HH:mm')}
        </gz-labeled-content>
        <gz-labeled-content label="${this.translations.lastUpdated}">
          ${moment(this.incident.lastUpdated).format('DD MMM YYYY, HH:mm')}
        </gz-labeled-content>
        ${!this.incident.isCustomer
          ? html` <gz-labeled-content label="${this.translations.company}">
              <gz-tooltip isEllipsis tooltiptext="${this.incident.company.name}"
                >${this.incident.company.name}</gz-tooltip
              >
            </gz-labeled-content>`
          : nothing}
        <gz-labeled-content label="${this.translations.severity}">
          <span class="cell-label has-bullet ${getSeverityClassFromScore(this.incident.score)}"
            >${this.incident.score}</span
          >
        </gz-labeled-content>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'incident-general-section': IncidentGeneralSectionWebComponent;
  }
}
